// eslint-disable-next-line import/no-extraneous-dependencies
import { isEqual } from 'lodash';

export const dataAppTitle = 'BNI QRIS - Portal Admin';

export const statusAuditTrail = [
  { value: 'success', text: 'Success' },
  { value: 'failed', text: 'Failed' },
];

export const rolePortalMerchant = [
  { value: 'Merchant', text: 'Merchant' },
  { value: 'Submerchant', text: 'Submerchant' },
  { value: 'Aggregator', text: 'Aggregator' },
  { value: 'Cashier', text: 'Cashier' },
  
];

export const transactionQrMethod = [
  { value: '0', text: 'MPM' },
  { value: '2', text: 'CPM' },
  { value: 'N001', text: 'QRIS TAP - Single' },
  { value: 'N004', text: 'QRIS TAP - Tap Out' },
  { value: 'N005', text: 'QRIS TAP - Tap Out Without Completion' },
];

export const productIndicatorOptions = [
  { value: 'N001', text: 'QRIS TAP - Single' },
  { value: 'N004', text: 'QRIS TAP - Tap Out' },
  { value: 'N005', text: 'QRIS TAP - Tap Out Without Completion' },
];

export const actionAuditTrail = [
  { text: 'CREATE', value: 'CREATE' },
  { text: 'UPDATE', value: 'UPDATE' },
  { text: 'DELETE', value: 'DELETE' },
  { text: 'VIEW', value: 'VIEW' },
  { text: 'OTHER', value: 'OTHER' },
];

export const dataTipeMerchantOnboarding = [
  { value: '1', text: 'Individu' },
  { value: '2', text: 'Badan Usaha' },
];

export const listClientVersion = [
  { value: '1', text: 'Non SNAP (MPM, CPM, NFC)' },
  { value: '2', text: 'SNAP (MPM)' },
];
export const listMerchantModel = [
  { value: '1', text: 'Merchant' },
  { value: '2', text: 'Marketplace' },
];

export const dataCptsMdrValues = {
  merchant: {
    mdr_on_us: 1,
    mdr_off_us: 1.3,
  },
  sub_merchant: {
    mdr_on_us: 0.7,
    mdr_off_us: 1.2,
  },
};

export const dataListMerchantCriteria = [
  { value: 'UMI', text: '(UMI) Usaha Mikro' },
  { value: 'UKE', text: '(UKE) Usaha Kecil' },
  { value: 'UME', text: '(UME) Usaha Menengah' },
  { value: 'UBE', text: '(UBE) Usaha Besar' },
  { value: 'URE', text: '(URE) Usaha Reguler' },
];

export const statusFileSettlement = [
  { value: '1', text: 'Active' },
  { value: '0', text: 'Inactive' },
];

export const fileTypeData = [
  { value: '1', text: 'txt' },
  { value: '2', text: 'csv' },
];

export const channelType = [
  { value: '1', text: 'SFTP' },
  { value: '2', text: 'Email' },
];

export const statusGenerateQr = [
  { value: '0', text: ' On Progress' },
  { value: '1', text: 'Complete' },
];

export const dataListMerchantCriteriaCorporate = [
  { value: 'UKE', text: '(UKE) Usaha Kecil' },
  { value: 'UME', text: '(UME) Usaha Menengah' },
  { value: 'UBE', text: '(UBE) Usaha Besar' },
  { value: 'URE', text: '(URE) Usaha Reguler' },
];

export const dataListMccMdrStatus = [
  { value_number: '1', value: '1', text: 'Active' },
  { value_number: '0', value: '0', text: 'Inactive' },
];

export const dataCategoryMccMdr = [
  { value_number: '1', value: '1', text: 'Reguler' },
  { value_number: '2', value: '2', text: 'Khusus' },
];

export const dataListTrxReportStatus = [
  { value_number: '1', value: '1', text: 'Success' },
  { value_number: '2', value: '2', text: 'On Progress' },
  // { value_number: "3", value: "3", text: "Pending" },
  { value_number: '4', value: '4', text: 'Failed' },
  { value_number: '5', value: '5', text: 'Reversed' },
];

export const promoCodeFilter = [
  {  value: 'QQ', text: 'Artajasa' },
  {  value: 'QF', text: 'Rintis' },
];

export const dataListTrxReportCptsStatus = [
  { value_number: '1', value: '1', text: 'Success' },
  // { value_number: '2', value: '2', text: 'On Progress' },
  { value_number: '3', value: '3', text: 'Pending' },
  { value_number: '4', value: '4', text: 'Failed' },
  // { value_number: '5', value: '5', text: 'Reversed' },
];

export const dataListPaymentType = [
  { value: 'on us', text: 'On Us' },
  { value: 'off us', text: 'Off Us' },
];

export const dataGetPaymentType = [
  { value: '1', text: 'On Us' },
  { value: '2', text: 'Off Us' },
];

export const dataListTrxType = [
  { value: '1', text: 'Pembayaran' },
  { value: '2', text: 'Refund' },
];

export const dataProfilingPaymentType = [
  { value: '1', text: 'On Us' },
  { value: '2', text: 'Off Us' },
];

export const dataListMerchantType = [
  { value: '1', text: 'merchant' },
  { value: '2', text: 'aggregator' },
  { value: '3', text: 'submerchant' },
];

export const dataListAccountStatus = [
  // { value: "0", text: "inactive" },
  { value: '1', text: 'active' },
  { value: '2', text: 'blocked' },
  { value: '3', text: 'closed' },
];

export const dataListTaskType = [
  { value: '0', text: 'Add New Merchant' },
  { value: '1', text: 'Add New Aggregator' },
  { value: '2', text: 'Add New Sub Merchant' },
  { value: '3', text: 'Add New Outlet' },
  { value: '4', text: 'Edit Merchant Data PTEN' },
  { value: '5', text: 'Edit Merchant Data Non PTEN' },
  { value: '6', text: 'Edit Aggregator' },
  { value: '7', text: 'Close Merchant' },
  { value: '8', text: 'Blokir Merchant' },
  { value: '9', text: 'Unblokir Merchant' },
  // { value: "10", text: "Blokir Aggregator" },
  // { value: "11", text: "Unblokir Aggregator" },
  // { value: "12", text: "Add Terminal (QR)" },
  // { value: "13", text: "Close Terminal (QR)" },
  // { value: "14", text: "Edit Rekening Setlement" },
  { value: '15', text: 'Edit Settlement Type' },
];

export const dataQrType = [
  { value: '1', text: 'QR Sticker' },
  { value: '3', text: 'QR EDC' },
  { value: '2', text: 'QR API' },
];

export const dataQrTypeWithCpts = [
  { value: '1', text: 'QR Sticker' },
  { value: '3', text: 'QR EDC' },
  { value: '2', text: 'QR API' },
  { value: '8', text: 'CPTS' },
];

export const dataAllQrType = [
  { value: '1', text: 'QR Sticker' },
  { value: '3', text: 'QR EDC' },
  { value: '2', text: 'QR API' },
  { value: '4', text: 'QR Sticker & API' },
  { value: '5', text: 'QR Sticker & API & EDC' },
  { value: '6', text: 'QR Sticker & EDC' },
  { value: '7', text: 'QR API & EDC' },
];

// qr type submerchant for onboarding
export const qrByMerchantType = (type) => {
  let individu = [];
  let corporate = [];
  let returnQr = {};

  switch (type) {
    case '1':
      individu.push({ value: '1', text: 'QR Sticker' });
      corporate.push({ value: '1', text: 'QR Sticker' });
      returnQr = { individu, corporate };
      break;
    case '2':
      individu.push({ value: '2', text: 'QR API' });
      corporate.push({ value: '2', text: 'QR API' });
      returnQr = { individu, corporate };
      break;
    case '3':
      individu.push({ value: '3', text: 'QR EDC' });
      corporate.push({ value: '3', text: 'QR EDC' });
      returnQr = { individu, corporate };
      break;
    case '4':
      individu.push({ value: '1', text: 'QR Sticker' });
      individu.push({ value: '2', text: 'QR API' });
      individu.push({ value: '4', text: 'QR Sticker & API' });
      corporate.push({ value: '1', text: 'QR Sticker' });
      corporate.push({ value: '2', text: 'QR API' });
      corporate.push({ value: '4', text: 'QR Sticker & API' });
      returnQr = { individu, corporate };
      break;
    case '5':
      individu = dataAllQrType;
      corporate = dataAllQrType;
      returnQr = { individu, corporate };
      break;
    case '6':
      individu.push({ value: '1', text: 'QR Sticker' });
      individu.push({ value: '3', text: 'QR EDC' });
      individu.push({ value: '6', text: 'QR Sticker & EDC' });
      corporate.push({ value: '1', text: 'QR Sticker' });
      corporate.push({ value: '3', text: 'QR EDC' });
      corporate.push({ value: '6', text: 'QR Sticker & EDC' });
      returnQr = { individu, corporate };
      break;
    case '7':
      individu.push({ value: '2', text: 'QR API' });
      individu.push({ value: '3', text: 'QR EDC' });
      individu.push({ value: '7', text: 'QR API & EDC' });
      corporate.push({ value: '2', text: 'QR API' });
      corporate.push({ value: '3', text: 'QR EDC' });
      corporate.push({ value: '7', text: 'QR API & EDC' });
      returnQr = { individu, corporate };
      break;
    default:
      returnQr = dataQrType;
      break;
  }

  return returnQr;
};

export const qrIdToArray = (type) => {
  switch (type) {
    case '1':
      return ['1'];
    case '2':
      return ['2'];
    case '3':
      return ['3'];
    case '4':
      return ['1', '2'];
    case '5':
      return ['1', '2', '3'];
    case '6':
      return ['1', '3'];
    case '7':
      return ['2', '3'];
    default:
      return [];
  }
};

export const qrArrayToId = (arr) => {
  if (arr.length == 1) {
    return arr[0];
  }
  const sorted = arr.sort();
  if (isEqual(['1', '2'], sorted)) {
    return '4';
  }
  if (isEqual(['1', '2', '3'], sorted)) {
    return '5';
  }
  if (isEqual(['1', '3'], sorted)) {
    return '6';
  }
  if (isEqual(['2', '3'], sorted)) {
    return '7';
  }

  return '';
};

// file type lowercase
export const validations = {
  file_ktp: { max: 900, type: ['image/jpeg', 'image/jpg', 'image/png'] },
  file_npwp: { max: 900, type: ['image/jpeg', 'image/jpg', 'image/png'] },
  file_logo: { max: 900, type: ['image/jpeg', 'image/jpg', 'image/png'] },
  file_foto_merchant: {
    max: 900,
    type: ['image/jpeg', 'image/jpg', 'image/png'],
  },
  file_qris: { max: 900, type: ['image/jpeg', 'image/jpg', 'image/png'] },
  file_bulk_merchant: {
    max: 900,
    type: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  },
  file_bulk_aggregator: {
    max: 900,
    type: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
  },
  mid: {
    min_length: 9,
    max_length: 9,
  },
  tid: {
    min_length: 10,
    max_length: 10,
  },
  remarkPTEN: {
    min_length: 5,
    max_length: 50,
  },
  image_broadcast: {
    max: 2000,
    type: [
      'image/jpeg',
      'image/jpg',
      'image/png',
      'image/gif',
      'image/webp',
      'image/avif',
    ],
    width: '640',
    height: '480',
  },
};

export const dataStatusRequest = [
  { value: '1', text: 'New' },
  { value: '2', text: 'Sendback' },
];

export const dataListIdApprover = [{ value: '20', text: 'ADMIN102030' }];

export const dataExpiredOtp = 10;

export const dataListStatusUser = [
  { value: '0', text: 'Inactive' },
  { value: '1', text: 'Active' },
  { value: '3', text: 'Dormant' },
  // { value: "2", text: "Blocked" },
  // { value: "4", text: "Deleted" },
];

export const dataListHistoryRmStatus = [
  { value: '1', text: 'New' },
  { value: '2', text: 'Need Revision' },
  { value: '3', text: 'Revised' },
  { value: '4', text: 'Rejected' },
];

export const dataListMwHoStatus = [
  { value: '1', text: 'New' },
  { value: '2', text: 'Revised' },
];

export const dataListHistoryMwHoStatus = [
  { value: '1', text: 'New' },
  { value: '2', text: 'Need Revision' },
  { value: '3', text: 'Revised' },
  { value: '4', text: 'Rejected' },
  { value: '5', text: 'Approved' },
];

export const scrollOptions = {
  duration: 1300,
  offset: 100,
  easing: 'easeInOutCubic',
};

export const dataListTrackingPengajuanStatus = [
  { value: '1', text: 'New' },
  { value: '2', text: 'Need Revision' },
  { value: '3', text: 'Revised' },
  { value: '4', text: 'On Progress Approver 1' },
  { value: '5', text: 'Rejected By Approver 1' },
  { value: '6', text: 'Approved by Approver 1' },
  { value: '7', text: 'On Progress Approver 2' },
  { value: '8', text: 'Rejected by Approver 2' },
  { value: '9', text: 'Approved by Approver 2' },
  { value: '71', text: 'Waiting To PTEN' },
  { value: '10', text: 'Send To PTEN' },
  // { value: "11", text: "Downloaded PTEN" },
  { value: '12', text: 'Reject by PTEN' },
  { value: '72', text: 'Waiting To Cardlink' },
  { value: '50', text: 'Send To Cardlink' },
  { value: '61', text: 'Waiting to Approval Activation' },
  { value: '62', text: 'Approve force active' },
  { value: '51', text: 'Waiting to Active' },
  { value: '13', text: 'Active' },
  { value: '14', text: 'Failed' },
];

export const resendEmail = 60;

export const dataUserRoles = [
  { value: 'APPROVER 1', text: 'APPROVER 1' },
  { value: 'APPROVER 2', text: 'APPROVER 2' },
  { value: 'SALES ADMIN', text: 'SALES ADMIN' },
  { value: 'SYSADMIN', text: 'SYSADMIN' },
];

export const dataExtraString3 = 'NzJJSkJqU3g5czRrWXE0bg==';

export const dataMaxSelectedApproval = 50;

export const dataMaxSelectedGenerateSettlement = 1000;

export const dataMaxSelectedBroadcast = 1000;

export const dataMaxSelectedChangePic = 50;

export const dataTransactionType = [
  { value: 'Debit', text: 'Debit' },
  { value: 'Credit', text: 'Credit' },
  { value: 'QRIS', text: 'QRIS' },
  { value: 'Tapcash', text: 'Tapcash' },
];

export const dataMinRangeDate = -30;

export const dataMaxRangeDate = 30;

export const dataVarcharMaxLength = 250;

export const dataRoleTypes = [
  { value: 'general', text: 'General' },
  { value: 'khusus', text: 'Khusus' },
  { value: 'inputer', text: 'Inputer' },
  { value: 'approver1', text: 'Approver 1' },
  { value: 'approver2', text: 'Approver 2' },
  { value: 'helpdesk_spe', text: 'Helpdesk SPE' },
  { value: 'it_ops_spe', text: 'IT Ops SPE' },
];

// interval 10 detik.
export const dataIntervalExport = 10000;

// interval 5 detik.
export const dataIntervalExportCh = 5000;

// interval 5 detik.
export const dataIntervalUpload = 5000;

// interval 5 detik.
export const dataIntervalSwitch = 5000;

// interval 5 detik.
export const dataIntervalRefund = 5000;

// interval 10 detik.
export const dataIntervalSettlement = 10000;

// interval 10 detik.
export const dataIntervalCheckFile = 10000;

export const dataWaitFileGenerate = true;

// 10x interval check file sebelum failed
export const dataMaxCheckFileInterval = 10;

// 2x interval check export status total success sama sebelum failed
export const dataMaxExportStatusInterval = 10;

export const dataBroadcastLogStatus = [
  { value: 'success', text: 'success' },
  { value: 'failed', text: 'failed' },
];

// delay 0.5 second
export const dataDelayServiceHit = 500;

export const dataApproverLimitPerHit = 200;

export const dataQrMethod = [
  { value: '0', text: 'MPM' },
  /* { value: "1", text: "CPM" }, */
  { value: '1', text: 'CPM Bansos' },
  { value: '2', text: 'CPM' },
];

export const dataListSettlementStatus = [
  { value: '0', text: 'N/A' },
  { value: '1', text: 'Settled' },
  { value: '2', text: 'Unsettled' },
  { value: '3', text: 'Failed' },
];

export const dataListEmailType = [
  { value: 'Activation Merchant', text: 'Activation Merchant' },
  // { value: "Edit Merchant Data PTEN", text: "Edit Merchant Data PTEN" },
  // { value: "Add New Merchant", text: "Add New Merchant" },
];

export const dataListPasswordChange = [
  { value: '0', text: 'Done' },
  { value: '1', text: 'Not yet' },
];

export const dataListStatusMerchant = [
  { value: '0', text: 'Inactive' },
  { value: '1', text: 'Active' },
  { value: '2', text: 'Blocked' },
  { value: '3', text: 'Dormant' },
  { value: '4', text: 'Deleted' },
];

export const dataResendEmailStatus = [
  { value: '0', text: 'waiting' },
  { value: '1', text: 'on process' },
  { value: '2', text: 'success' },
  { value: '3', text: 'failed' },
];

export const dataSettlementTypeItems = [
  {
    value: '0',
    text: 'H+0',
  },
  {
    value: '1',
    text: 'H+1',
  },
];

export const sof = [
  { value: '0', text: 'Default' },
  { value: '1', text: 'Debit' },
  { value: '2', text: 'Credit' },
  { value: '3', text: 'Emoney' },
  { value: '4', text: 'Lain-lain' },
];

export const getListYear = [
  { value: '2018', text: '2018' },
  { value: '2019', text: '2019' },
  { value: '2020', text: '2020' },
  { value: '2021', text: '2021' },
  { value: '2022', text: '2022' },
  { value: '2023', text: '2023' },
  { value: '2024', text: '2024' },
  { value: '2025', text: '2025' },
  { value: '2026', text: '2026' },
  { value: '2027', text: '2027' },
  { value: '2028', text: '2028' },
  { value: '2029', text: '2029' },
  { value: '2030', text: '2030' },
  { value: '2031', text: '2031' },
  { value: '2032', text: '2032' },
  { value: '2033', text: '2033' },
  { value: '2034', text: '2034' },
  { value: '2035', text: '2035' },
  { value: '2036', text: '2036' },
  { value: '2037', text: '2037' },
  { value: '2038', text: '2038' },
  { value: '2039', text: '2039' },
  { value: '2040', text: '2040' },
  { value: '2041', text: '2041' },
  { value: '2042', text: '2042' },
  { value: '2043', text: '2043' },
  { value: '2044', text: '2044' },
  { value: '2045', text: '2045' },
];

export const dataSourceOnboardingList = [
  { value: '0', text: 'N/A' },
  { value: '1', text: 'BNI MOM' },
  { value: '2', text: 'BNI Merchant' },
  { value: '3', text: 'BNI Move' },
];
export const dataPromoTypeList = [
  { value: 1, text: 'All Merchant' },
  { value: 3, text: 'Select Merchant' },
  { value: 2, text: 'Bulk Upload Merchant' },
];

export const dataJenisPromoList = [
  { value: 1, text: 'Discount' },
  { value: 2, text: 'Cashback' },
];

export const dataListPromoStatus = [
  { value: 0, text: 'Inactive' },
  { value: 1, text: 'Active' },
  { value: 2, text: 'Expired' },
];
// end report Wallet
